import { Input } from "../ui/input";

/**
 * Editable title of a running / swim / bike / erg exercise. Shared by the
 * three endurance forms: the name is generated from the type until the coach
 * (or the AI) writes one, and an empty field falls back to the generated name
 * on save (`handleAddExercise`).
 */
export function EnduranceNameField({ newExercise, setNewExercise, t }) {
	return (
		<div className="space-y-1">
			<span className="text-[10px] text-muted-foreground uppercase tracking-wider">
				{t("exerciseName")}
			</span>
			<Input
				value={newExercise.exercise_name ?? ""}
				onChange={(e) =>
					setNewExercise({
						...newExercise,
						exercise_name: e.target.value,
					})
				}
				className="bg-secondary border-transparent rounded-sm text-xs"
				placeholder={t("exerciseNamePlaceholder")}
			/>
			<p className="text-[10px] text-muted-foreground">
				{t("pbEnduranceNameAutoHint")}
			</p>
		</div>
	);
}

export default EnduranceNameField;
